module.exports = __webpack_public_path__ + "media/assets/faria_products/CAM-LS-4b983b0a42541b013c601289ed1804717931b758326d425570302ce4a63d1e76.svg";